import React from "react";
import dataScience from "../datascience.js";
import dataViz from "../dataviz.js";
import miscellaneous from "../miscellaneous.js";
import ScrollAnimation from 'react-animate-on-scroll';
import githubImage from "./resources/github_img.png";
import openLink from "./resources/open_in_new.png";
import instagramImage from "./resources/INSTAGRAM link.png";
import { useEffect } from "react";

function Lab() {
    useEffect(() => {
        window.scrollTo(0,0)
    },[])
    return (
        <div className="whatIDo lab-content">
            <ScrollAnimation animateIn="fadeIn" delay={500} animateOnce={false}>
                <h3 className="block-heading lab-heading">LAB</h3>
                <p className="grey-note grey-note-2">DATA SCIENCE</p>
                <div className="grey-line"></div>
            </ScrollAnimation>
            <ScrollAnimation animateIn="fadeIn" delay={500} animateOnce={false}>
                <div className="data-science">
                    {dataScience.map((ds, index) => {
                            return (
                                <div className="card" key={index}>
                                    <h2 className="title">{ds.proj_title}</h2>
                                    <p className="description">{ds.proj_description}</p> 
                                    <a target="_blank" rel="noreferrer" className="proj-link" href={ds.link} ><img src={githubImage} alt="" /></a>
                                </div>
                            );
                        })}
                </div>
            </ScrollAnimation>
            
            <ScrollAnimation animateIn="fadeIn" delay={500} animateOnce={false}>
                <p className="grey-note grey-note-2">DATA VISUALIZATION</p>
                <div className="grey-line"></div>
            </ScrollAnimation>
            <ScrollAnimation animateIn="fadeIn" delay={500} animateOnce={false}>
                <div className="data-viz">
                    {dataViz.map((dv, index) => {
                            return (
                                <div className="card" key={index}>
                                    <div className="dataviz-img">
                                        <img src={dv.proj_img} alt="" />
                                    </div><br />
                                    <h2 className="title">{dv.proj_title}</h2>
                                    <p className="description">{dv.proj_description}</p> 
                                    <a target="_blank" rel="noreferrer" className="proj-link" href={dv.link} ><img src={openLink} alt="" /></a>
                                </div>
                            );
                        })}
                </div>
            </ScrollAnimation>
            
            <ScrollAnimation animateIn="fadeIn" delay={500} animateOnce={false}>
                <p className="grey-note grey-note-2">PUBLICATION</p>
                <div className="grey-line"></div>
                <div className="publication-content">
                    <h2 className="title paper-link">
                    StoryGenAI: An Automatic Genre-Keyword Based Story Generation</h2>
                    <p className="description">IEEE | 21 Jul, 2023</p><br/>
                    <h2 className="title paper-link">An Efficient Supervised Deep Learning Approach for Covid chest Image Classification from Deep Residual Networks</h2>
                    <p className="description">IEEE | 10 Dec, 2021</p>
                </div>
            </ScrollAnimation>
            
            <ScrollAnimation animateIn="fadeIn" delay={500} animateOnce={false}>
                <p className="grey-note grey-note-2">MISCELLANEOUS</p>
                <div className="grey-line"></div>
             </ScrollAnimation>
            <ScrollAnimation animateIn="fadeIn" delay={500} animateOnce={false}>
                <div className="mis-content">
                    <div className="insta-link">
                        <a target="_blank" rel="noreferrer" href="https://www.instagram.com/kaiyaaa_leah/"><img className="insta-link-img" src={instagramImage} alt="" /></a>
                        <p className=" description insta-link-text">You can see more here</p>
                    </div>
                    <div className="misc-content">
                        {miscellaneous.map((mi, index) => {
                            return (
                                <div key={index}>
                                    <div className="misc-img">
                                        <img src={mi.image} alt="" />
                                    </div><br />
                                </div>
                            );
                        })}
                    </div>
                    
                </div>
            </ScrollAnimation>
        </div>
    );
};

export default Lab;